import { CustomersLayout } from './components/CustomersLayout';
import { CustomersPage } from './components/list/CustomersPage';
import { CustomerDetailPage } from './components/detail/CustomerDetailPage';
import { CustomerSegmentsPage } from './components/segments/CustomerSegmentsPage';
import { CustomerSegmentDetailPage } from './components/segments/CustomerSegmentDetailPage';
import { CustomerAnalyticsPage } from './components/analytics/CustomerAnalyticsPage';

export const customerRoutes = {
  element: <CustomersLayout />,
  children: [
    {
      index: true,
      element: <CustomersPage />
    },
    {
      path: ':id',
      element: <CustomerDetailPage />
    },
    {
      path: 'segments',
      element: <CustomerSegmentsPage />
    },
    {
      path: 'segments/:id',
      element: <CustomerSegmentDetailPage />
    },
    {
      path: 'analytics',
      element: <CustomerAnalyticsPage />
    }
  ]
}; 